import {Collapse} from 'antd'
import styled from 'styled-components'

export const Root = styled.div`
    padding: 10px 10px;
`
